<ng-container *ngIf="quickComposer; else sendSmsDefaultComposer">
  <div
    class="send-sms-quick"
    [class.send-sms-quick--filled]="hasQuickDraft"
    [class.send-sms-quick--join]="showJoinNowButton"
  >
    <div class="send-sms-quick__row">
      <div class="send-sms-quick__field position-relative min-w-0 flex-grow-1">
        <textarea
          class="send-sms-quick__input"
          rows="1"
          placeholder="Send a message"
          aria-label="Send a message"
          [(ngModel)]="messageText"
          (ngModelChange)="onMessageInput()"
          (keydown)="onKeyDown($event)"
          [disabled]="!showSmsComposer || isSending"
        ></textarea>
        <div *ngIf="showTemplateDropdown" class="template-dropdown">
          <div class="template-dropdown-header d-flex justify-content-between align-items-center mb-2">
            <span></span>
            <a class="show-all-link" (click)="openSavedRepliesModal(); $event.stopPropagation()">Show all ({{ messageTemplates.length }})</a>
          </div>
          <div *ngIf="isLoadingTemplates" class="template-dropdown-loading">
            <i class="fa-duotone fa-spinner-third fa-spin"></i> Loading...
          </div>
          <div *ngIf="!isLoadingTemplates && filteredTemplates.length === 0" class="template-dropdown-empty">
            No templates found
          </div>
          <div *ngIf="!isLoadingTemplates && filteredTemplates.length > 0" class="template-dropdown-list">
            <div
              *ngFor="let template of filteredTemplates"
              class="template-dropdown-item"
              (click)="selectTemplate(template)"
            >
              <div class="template-title">{{ template.title }}</div>
              <div class="template-preview">{{ template.response_message }}</div>
            </div>
          </div>
        </div>
      </div>
      <div
        *ngIf="showJoinNowButton"
        class="join-conversation-wrap send-sms-quick__join flex-shrink-0"
        [class.disabled]="isJoining || isAssignedToEveryoneOnReferral"
        [attr.title]="
          isAssignedToEveryoneOnReferral
            ? 'Assign this referral to a specific user (not Everyone) before you can join or send SMS.'
            : null
        "
      >
        <button type="button" class="send-sms-quick__join-btn" (click)="joinConversation()">
          <i *ngIf="isJoining" class="fa-duotone fa-spinner-third fa-spin me-1"></i>
          Join now
        </button>
      </div>
    </div>
    <div
      *ngIf="showSmsComposer && hasQuickDraft"
      class="send-sms-quick__actions d-flex align-items-center justify-content-end gap-1"
    >
      <button
        type="button"
        class="send-sms-quick__icon-btn send-sms-quick__icon-btn--muted"
        [disabled]="isSending"
        (click)="discardQuickDraft()"
        title="Discard"
        aria-label="Discard message"
      >
        <i class="fa-solid fa-xmark" aria-hidden="true"></i>
      </button>
      <button
        type="button"
        class="send-sms-quick__icon-btn send-sms-quick__icon-btn--primary"
        [disabled]="isSending || (!messageText.trim() && !attachedFile)"
        (click)="sendMessage()"
        title="Send message"
        aria-label="Send message"
      >
        <i *ngIf="isSending" class="fa-duotone fa-spinner-third fa-spin" aria-hidden="true"></i>
        <i *ngIf="!isSending" class="fa-solid fa-check" aria-hidden="true"></i>
      </button>
    </div>
  </div>
</ng-container>
<ng-template #sendSmsDefaultComposer>
<div *ngIf="showJoinNowButton" class="text-center w-100">
  <div
    class="join-conversation-wrap d-inline-block"
    [class.disabled]="isJoining || isAssignedToEveryoneOnReferral"
    [attr.title]="
      isAssignedToEveryoneOnReferral
        ? 'Assign this referral to a specific user (not Everyone) before you can join or send SMS.'
        : null
    "
  >
    <button
      type="button"
      class="btn text-primary"
      (click)="joinConversation()"
    >
      <i *ngIf="isJoining" class="fa-duotone fa-spinner-third fa-spin me-1"></i>
      Join now
    </button>
  </div>
</div>
<div class="sms-input-container" *ngIf="showSmsComposer">
  <div class="attachment-preview" *ngIf="attachedFile">
    <div class="attachment-card">
      <img *ngIf="attachedFilePreview" [src]="attachedFilePreview" alt="Preview" class="attachment-preview-img">
      <i *ngIf="!attachedFilePreview" class="fa-solid fa-file attachment-icon"></i>
      <span class="attachment-name">{{ attachedFile.name }}</span>
      <button type="button" class="btn-remove-attachment" (click)="removeAttachment()" title="Remove attachment">
        <i class="fa-solid fa-times"></i>
      </button>
    </div>
  </div>
  <div class="input-wrapper position-relative"
       [class.drag-over]="isDragOver"
       (dragover)="onDragOver($event)"
       (dragleave)="onDragLeave($event)"
       (drop)="onDrop($event)">
    <div class="d-flex gap-2 align-items-end">
      <input
        type="file"
        #fileInput
        class="d-none"
        (change)="onFileSelect($event)"
        [accept]="allowedFileTypes.join(',')"
      />
      <button
        type="button"
        class="btn btn-link p-1 text-muted flex-shrink-0"
        (click)="openFilePicker()"
        [disabled]="isSending"
        title="Attach file"
        aria-label="Attach file"
      >
        <i class="fa-solid fa-paperclip"></i>
      </button>
      <div class="flex-grow-1 position-relative">
        <textarea 
          class="form-control message-input" 
          rows="1"
          placeholder="Add Message..."
          [(ngModel)]="messageText"
          (ngModelChange)="onMessageInput()"
          (paste)="onPaste($event)"
          (keydown)="onKeyDown($event)"
          [disabled]="isSending"></textarea>
        <div *ngIf="showTemplateDropdown" class="template-dropdown">
          <div class="template-dropdown-header d-flex justify-content-between align-items-center mb-2">
            <span></span>
            <a class="show-all-link" (click)="openSavedRepliesModal(); $event.stopPropagation()">Show all ({{ messageTemplates.length }})</a>
          </div>
          <div *ngIf="isLoadingTemplates" class="template-dropdown-loading">
            <i class="fa-duotone fa-spinner-third fa-spin"></i> Loading...
          </div>
          <div *ngIf="!isLoadingTemplates && filteredTemplates.length === 0" class="template-dropdown-empty">
            No templates found
          </div>
          <div *ngIf="!isLoadingTemplates && filteredTemplates.length > 0" class="template-dropdown-list">
            <div *ngFor="let template of filteredTemplates" 
                 class="template-dropdown-item"
                 (click)="selectTemplate(template)">
              <div class="template-title">{{ template.title }}</div>
              <div class="template-preview">{{ template.response_message }}</div>
            </div>
          </div>
        </div>
      </div>
      <button 
        type="button" 
        class="btn primary-button gradient send-btn d-flex align-items-center justify-content-center" 
        style="width:32px;height:32px;border-radius: 6px !important"
        (click)="sendMessage()"
        [disabled]="isSending || (!messageText.trim() && !attachedFile)">
        <i *ngIf="isSending" class="fa-duotone fa-spinner-third fa-spin"></i>
        <i *ngIf="!isSending" class="fal fa-arrow-up"></i>
      </button>
    </div>
  </div>
</div>
</ng-template>
